import { LIBELLE_NIVEAU } from '@/shared/auth/droits';
import type { Utilisateur } from '@/shared/auth/types';

/** « CEO », « Administrateur », « Bâti Sud Charpente », ou « En attente de rattachement ». */
export function libelleRole(utilisateur: Utilisateur): string {
  if (utilisateur.role === 'bureau') {
    return utilisateur.niveau ? LIBELLE_NIVEAU[utilisateur.niveau] : 'Bureau';
  }
  return utilisateur.partenaireNom ?? 'En attente de rattachement';
}
